(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-builder]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const steps = [...root.querySelectorAll('[data-bundle-step]')];
    const selections = new Map();
    let activeStep = 0;

    const money = (value) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(value, root.dataset.moneyFormat);
      const format = root.dataset.moneyFormat || '$' + '{' + '{amount}' + '}';
      return format.replace('{{amount}}', (value / 100).toFixed(2));
    };

    const removeIcon = root.querySelector('[data-bundle-remove-icon]')?.innerHTML || '';

    const currentSelection = () => [...selections.values()].flat();

    const render = () => {
      steps.forEach((step, index) => step.classList.toggle('is-active', index === activeStep));
      root.querySelectorAll('[data-bundle-step-button]').forEach((button) => {
        const index = Number(button.dataset.bundleStepButton);
        button.classList.toggle('is-active', index === activeStep);
        button.classList.toggle('is-complete', index < activeStep);
      });
      const totalSelected = currentSelection().length;
      const completedSteps = steps.filter(
        (step, index) => (selections.get(index)?.length || 0) >= Number(step.dataset.minimum || 0)
      ).length;
      root.querySelector('[data-summary-progress]').textContent = `${totalSelected} product${
        totalSelected === 1 ? '' : 's'
      } selected · ${completedSteps} of ${steps.length} steps completed`;
      const selected = root.querySelector('[data-bundle-selected]');
      selected.innerHTML = '';
      let total = 0;
      currentSelection().forEach((item) => {
        total += item.price * item.quantity;
        const row = document.createElement('div');
        row.className = 'bundle-builder__summary-item';
        row.innerHTML = `<img src="${item.image}" alt=""><p>${item.title} × ${item.quantity}<br><small>${money(
          item.price * item.quantity
        )}</small></p><button type="button" class="button-secondary bundle-builder__remove" data-remove-id="${
          item.key
        }" aria-label="Remove ${item.title}" title="Remove ${item.title}">${removeIcon}</button>`;
        selected.append(row);
      });
      if (!currentSelection().length)
        selected.innerHTML = '<p class="bundle-builder__summary-empty">Your selected products will appear here.</p>';
      root.querySelector('[data-bundle-total]').textContent = money(total);
      root.querySelector('[data-bundle-cart]').disabled = !totalSelected;
      root.querySelectorAll('[data-bundle-product]').forEach((card) => {
        const step = card.closest('[data-bundle-step]');
        const stepIndex = steps.indexOf(step);
        const stepItems = selections.get(stepIndex) || [];
        const selectedItem = stepItems.find((item) => item.variantId === card.dataset.variantId);
        const maximum = Number(step.dataset.maximum || 0);
        card.classList.toggle('is-selected', Boolean(selectedItem));
        card.querySelector('[data-bundle-select-label]').textContent = selectedItem ? '✓ Added' : '+ Add';
        card.querySelector('[data-bundle-select]').disabled =
          !selectedItem && maximum > 0 && stepItems.length >= maximum;
      });
    };

    const validate = (index) => {
      const step = steps[index];
      if (!step) return true;
      const count = selections.get(index)?.length || 0;
      const minimum = Number(step.dataset.minimum || 0);
      const maximum = Number(step.dataset.maximum || 0);
      const validation = step.querySelector('[data-step-validation]');
      if (count < minimum) {
        validation.textContent = `Select at least ${minimum} product${minimum === 1 ? '' : 's'} to continue.`;
        validation.hidden = false;
        return false;
      }
      if (maximum && count > maximum) {
        validation.textContent = `Select no more than ${maximum} product${maximum === 1 ? '' : 's'}.`;
        validation.hidden = false;
        return false;
      }
      validation.hidden = true;
      return true;
    };

    root.addEventListener('click', async (event) => {
      const selectButton = event.target.closest('[data-bundle-select]');
      const removeButton = event.target.closest('[data-remove-id]');
      const nextButton = event.target.closest('[data-bundle-next]');
      const previousButton = event.target.closest('[data-bundle-previous]');
      const cartButton = event.target.closest('[data-bundle-cart]');
      const stepButton = event.target.closest('[data-bundle-step-button]');
      if (stepButton) {
        const targetStep = Number(stepButton.dataset.bundleStepButton);
        if (targetStep <= activeStep || validate(activeStep)) {
          activeStep = targetStep;
          render();
        }
        return;
      }
      if (selectButton) {
        const card = selectButton.closest('[data-bundle-product]');
        const step = card.closest('[data-bundle-step]');
        const index = steps.indexOf(step);
        const items = selections.get(index) || [];
        const variantId = card.dataset.variantId;
        const key = `${index}:${variantId}`;
        const existing = items.findIndex((item) => item.variantId === variantId);
        if (existing >= 0) items.splice(existing, 1);
        else if (!Number(step.dataset.maximum) || items.length < Number(step.dataset.maximum)) {
          const variant = card.querySelector('[data-bundle-variant]');
          const option = variant?.selectedOptions[0];
          items.push({
            key,
            variantId: variant?.value || variantId,
            quantity: 1,
            title: card.querySelector('h4').textContent.trim(),
            price: Number(option?.dataset.priceCents || card.dataset.priceCents || 0),
            image: card.querySelector('img')?.src || '',
          });
        }
        selections.set(index, items);
        render();
        return;
      }
      if (removeButton) {
        for (const [index, items] of selections)
          selections.set(
            index,
            items.filter((item) => item.key !== removeButton.dataset.removeId)
          );
        render();
        return;
      }
      if (nextButton && validate(activeStep)) {
        activeStep = Math.min(activeStep + 1, steps.length - 1);
        render();
        return;
      }
      if (previousButton) {
        activeStep = Math.max(activeStep - 1, 0);
        render();
        return;
      }
      if (cartButton && !cartButton.disabled) {
        cartButton.disabled = true;
        root.querySelector('[data-bundle-cart-message]').textContent = 'Adding your bundle…';
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: currentSelection().map((item) => ({
                id: item.variantId,
                quantity: item.quantity,
                properties: { _bundle_builder: root.dataset.sectionId },
              })),
            }),
          });
          if (!response.ok) throw new Error('Cart request failed');
          root.querySelector('[data-bundle-cart-message]').textContent =
            'Bundle added to cart. Redirecting to checkout…';
          window.location.assign('/checkout');
        } catch (error) {
          root.querySelector('[data-bundle-cart-message]').textContent = 'Unable to add the bundle. Please try again.';
          cartButton.disabled = false;
        }
      }
    });

    root.querySelectorAll('[data-bundle-variant]').forEach((variant) =>
      variant.addEventListener('change', () => {
        const card = variant.closest('[data-bundle-product]');
        card.dataset.variantId = variant.value;
        card.dataset.priceCents = variant.selectedOptions[0]?.dataset.priceCents || '0';
        render();
      })
    );
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
